export const CLIENT_LOG_QUEUE_LIMIT = 50

export class ClientLogQueue {
    constructor(send) {
        this.send = send
        this.queue = []
        this.generation = 0
        this.running = false
        this.dropped = 0
    }
    enqueue(event) {
        if (this.queue.length >= CLIENT_LOG_QUEUE_LIMIT) { this.queue.shift(); this.dropped++ }
        this.queue.push({ event, created: Date.now(), tries: 0 })
        void this.flush()
    }
    async flush() {
        if (this.running || this.timer || !this.queue.length || globalThis.navigator?.onLine === false) return
        while (this.queue.length && Date.now() - this.queue[0].created > 300000) {
            this.queue.shift(); this.dropped++
        }
        const item = this.queue.shift()
        if (!item) return
        const generation = this.generation
        this.running = true
        this.controller = new AbortController()
        const dropped = this.dropped
        if (item.event.diagnostics) item.event.diagnostics.dropped_records = dropped
        let delay = 11000
        try {
            await this.send(item.event, this.controller.signal)
            if (generation === this.generation && item.event.diagnostics) this.dropped = Math.max(0, this.dropped - dropped)
        } catch (error) {
            if (generation !== this.generation) return
            if (++item.tries < 3 && ![400, 401, 403].includes(error?.status)) {
                if (this.queue.length < CLIENT_LOG_QUEUE_LIMIT) this.queue.unshift(item)
                else this.dropped++
                delay = error?.status === 429 ? 60000 : 30000
            } else this.dropped++
        } finally {
            if (generation === this.generation) {
                this.running = false
                this.timer = setTimeout(() => { this.timer = null; void this.flush() }, delay)
            }
        }
    }
    reset() {
        this.generation++
        this.controller?.abort()
        clearTimeout(this.timer)
        this.timer = null
        this.running = false
        this.queue = []
        this.dropped = 0
    }
}
